// El botón que trae la siguiente página del servidor y la suma a la pila (ESTANDAR-TABLAS §5.4).
import { Button } from '@/kit';
import { cn } from '@/lib/cn';
import {
    LOADING_MORE_LABEL,
    LOAD_MORE_LABEL,
    RETRY_LOAD_MORE_LABEL,
    loadMoreNote,
    type LoadedNoun,
} from './loadedScope';

export interface LoadMoreButtonProps {
    /** El sustantivo de las filas, para lo que el botón explica al pasar el puntero. */
    noun: LoadedNoun;
    /** La página pedida todavía viaja: el botón lo dice y no acepta otro clic. */
    isLoading: boolean;
    /** La última página falló: el botón invita a repetirla en vez de a seguir avanzando. */
    hasFailed?: boolean;
    onLoadMore: () => void;
    className?: string;
}

export function LoadMoreButton({
    noun,
    isLoading,
    hasFailed = false,
    onLoadMore,
    className,
}: LoadMoreButtonProps) {
    // `aria-disabled` y no `disabled`: el botón sigue enfocable, así que el lector de pantalla
    // llega a su `title` y sabe qué trae.
    return (
        <Button
            variant="outline"
            size="sm"
            aria-disabled={isLoading}
            title={loadMoreNote(noun)}
            className={cn('aria-disabled:cursor-default aria-disabled:opacity-70', className)}
            onClick={() => {
                if (isLoading) return;
                onLoadMore();
            }}
        >
            {isLoading ? LOADING_MORE_LABEL : hasFailed ? RETRY_LOAD_MORE_LABEL : LOAD_MORE_LABEL}
        </Button>
    );
}
